import { Injectable, EventEmitter }    from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, Http } from '@angular/http';
import { ThirdParty } from '../entity/third-party';

@Injectable()
export class SignupService {

  private headers = new Headers({'Content-Type': 'application/json'});
  
  constructor(private http: Http) {
    
  }

  checkSiret(siret): Promise<ThirdParty> {
    return this.http.post(environment.apiUrl+'site-signup/check-siret', JSON.stringify({siret: siret}), {headers: this.headers})
                    .toPromise()
                    .then(
                      function(response) {
                        let thirdParty = new ThirdParty();
                        thirdParty.fromJSON(response.json());
                        return thirdParty;
                      })
                    .catch(this.handleError);
  }

  signup(thirdPartyId, mail, password): Promise<any> {
    return this.http.post(environment.apiUrl+'site-signup/signup', JSON.stringify({thirdPartyId: thirdPartyId, mail: mail, password: password}), {headers: this.headers})
                    .toPromise()
                    .then(response => response.json())
                    .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  checkEmail(email): Promise<boolean> {
    return this.http.post(environment.apiUrl+'site-signup/email/check', JSON.stringify({email: email}), {headers: this.headers})
                    .toPromise()
                    .then(
                      function(response) {
                        let data = response.json();
                        return data['available'];
                      })
                    .catch(this.handleError);
  }

}


// WEBPACK FOOTER //
// ./src/app/signup/signup.service.ts